import { createSlice } from "@reduxjs/toolkit";

const completionSlice = createSlice({
  name: "completion",
  initialState: {
    value: 0,   // default completion value
  },
  reducers: {
    setCompletion: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setCompletion } = completionSlice.actions;
export default completionSlice.reducer;
